export const steddyTransition = { duration: 0.5, ease: [0.2, 0.8, 0.2, 1] as const };

export const fadeInUp = {
  initial: { opacity: 0, y: 16 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: steddyTransition,
};
